import React, { useState } from "react";

const SingleSelectField = ({ label = "Sort By", options = [], selected = null, onChange }) => {
    const [open, setOpen] = useState(false);

    const handleSelect = (option) => {
        onChange(option);
        setOpen(false);
    };

    return (
        <div className="relative inline-block w-56 text-left">
            <label className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
            <button
                onClick={() => setOpen(!open)}
                className="inline-flex w-full justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none"
            >
                <span className="truncate">{selected ? selected.name : "Select field"}</span>
                <svg className="ml-2 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.586l3.71-4.356a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>

            {open && (
                <div className="absolute z-[300] mt-2 max-h-60 w-full origin-top-right overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="py-1">
                        {options.map((option) => (
                            <button
                                key={option.id}
                                onClick={() => handleSelect(option)}
                                className={`flex w-full items-center px-4 py-2 text-left text-sm hover:bg-gray-100 ${
                                    selected?.id === option.id
                                        ? "bg-gray-100 font-semibold text-gray-900"
                                        : "text-gray-700"
                                }`}
                            >
                                {option.name}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SingleSelectField;
